import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WheelIndicator from 'wheel-indicator'
import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'
import withWorks from '../hoc/withWorks'
import Project from './Project'
import workProp from '../workProp'
import Pagination from './Pagination'
import DarkMode from './DarkMode'
import * as Helpers from '../helpers'
import * as consts from '../constants'

class DesktopWorks extends Component {
  state = {
    activeIndex: 0,
    isPlaying: false,
  }

  componentDidMount() {
    this.dm = new DarkMode()
    this.handleInitialSlide()
    this.mouseIndicator = new WheelIndicator({ callback: this.handleMouseWheel })
  }

  componentWillUnmount() {
    this.dm.off()
    this.mouseIndicator.destroy()
  }

  handleMouseWheel = (e) => {
    if (e.direction === 'down') {
      const index = this.state.activeIndex < this.props.works.length - 1
        ? this.state.activeIndex + 1
        : 0
      this.swiper.slideTo(index)
    } else {
      const index = this.state.activeIndex > 0
        ? this.state.activeIndex - 1
        : this.props.works.length - 1
      this.swiper.slideTo(index)
    }
  }

  handleInitialSlide() {
    const { slug } = this.props.match.params

    setTimeout(() => {
      if (!this.swiper.destroyed) {
        const index = slug
          ? this.props.works.findIndex(work => work.slug === slug)
          : 0

        this.swiper.slideTo(index, index * 500)
      }
    }, 1500)
  }

  handleTogglePlay = (shouldPlay) => {
    if (shouldPlay) {
      this.dm.on()
    } else {
      this.dm.off()
    }
    this.setState({ isPlaying: shouldPlay })
  }

  handlePosterClick = () => {
    const { isPlaying } = this.state

    if (isPlaying) {
      this.dm.off()
      this.setState({ isPlaying: false })
      setTimeout(() => { this.swiper.slideTo(this.swiper.clickedIndex) }, 600)
    } else {
      this.swiper.slideTo(this.swiper.clickedIndex)
    }
  }

  handleThumbClick = index => () => {
    if (this.state.isPlaying) {
      this.dm.off()
      this.setState({ isPlaying: false })
      setTimeout(() => this.swiper.slideTo(index), 600)
    } else {
      this.swiper.slideTo(index)
    }
  }

  handleSlideChange = () => {
    const { activeIndex } = this.swiper
    this.setState({ isPlaying: false })

    const { slug } = this.props.works[activeIndex]
    this.props.history.push(`/works/${slug}`)

    setTimeout(() => {
      this.setState({ activeIndex })
    }, 100)
  }

  handleRef = (node) => {
    if (node) {
      this.swiper = node.swiper
    }
  }

  render() {
    const { width, height, works } = this.props
    const headerHeight = width < consts.MOBILE_BREAKPOINT
      ? consts.HEADER_HEIGHT
      : consts.HEADER_HEIGHT_SMALL
    const containerMaxHeight = height - headerHeight - consts.THUMBS_AND_INFO_MIN_HEIGHT
    const widestRatio = Helpers.getWidestVideoRatio(works)
    const videoHeight = Helpers.getHeightFromWidestVideo(width, widestRatio, containerMaxHeight)
    const paginationTop = Math.round(videoHeight + consts.PROJECT_INFO_HEIGHT)

    return (
      <div
        className="desktop-works"
        style={{ width }}
      >
        <Swiper
          shouldSwiperUpdate
          slidesPerView="auto"
          centeredSlides
          speed={800}
          keyboard
          roundLengths
          on={{
            slideChange: this.handleSlideChange,
          }}
          ref={this.handleRef}
        >
          {works.map((work, index) => {
            const videoWidth = Helpers.getWidthFromHeight(videoHeight, work.videoRatio)

            return (
              <div
                key={work.slug}
                style={{ width: videoWidth }}
                id="works"
              >
                <Project
                  director={work.director}
                  poster={work.images[0].original}
                  slug={work.slug}
                  title={work.title}
                  videoRatio={work.videoRatio}
                  videoUrl={work.videoUrl}
                  height={videoHeight}
                  width={videoWidth}
                  onClick={this.handlePosterClick}
                  onTogglePlay={this.handleTogglePlay}
                  isActive={index === this.state.activeIndex}
                  isPlaying={this.state.isPlaying}
                />
              </div>
            )
          })}
        </Swiper>
        <Pagination
          works={works}
          activeIndex={this.state.activeIndex}
          onClick={this.handleThumbClick}
          top={paginationTop}
        />
      </div>
    )
  }
}

DesktopWorks.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  // eslint-disable-next-line
  works: workProp.isRequired,
}

DesktopWorks.defaultProps = {
  match: {
    params: {
      slug: '',
    },
  },
}

export default withWorks(DesktopWorks)



// WEBPACK FOOTER //
// ./src/components/DesktopWorks.js